import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AppStyled = styled.div`
  min-height: 100vh;
  display: flex;
  width: 100%;
`;
